import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 5rem;
  width: 100%;
`;

export const Top = {
  Wrapper: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  Text: styled.div`
    font-size: 2.4rem;

    & > span {
      color: #2a4cff;
    }
  `,
  BtnContainer: styled.div`
    display: flex;
    gap: 1rem;
  `,
  Btn: styled.img`
    width: 4.4rem;
    height: 4.4rem;
  `,
};

export const Body = {
  Wrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    border-top: 0.1rem solid #7f7f7f;
    margin-top: 1rem;
  `,

  Img: styled.img`
    width: 33.5rem;
    height: 33.5rem;
    margin-top: 1rem;
  `,

  Title: styled.div`
    margin-top: 1rem;
    font-weight: bold;
    font-size: 3.2rem;
  `,

  Text: styled.div`
    margin-top: 1rem;
    font-size: 1.6rem;
    color: #666;
    margin-bottom: 6rem;
    line-height: 2.4rem;
  `,
};
